module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/4_8ddb8901fc0d12fb682545bb95c7e1a5.png";